import type { InputTrigger } from "@/lib/input-trigger";
import type { InputTargetConversation } from "@/api/conversation-targets";
import { removeInputTargetTrigger } from "@/lib/input-trigger";

export interface StandaloneBarChip {
  label: string;
  offset: number;
  row?: InputTargetConversation | null;
}

export interface StandaloneBarDraft {
  text: string;
  chip: StandaloneBarChip | null;
}

/** Keep a chip attached to its text position through controlled writes such
 * as dictation, desktop paste and the selection-quote prefill. */
export function rebaseChipOffset(
  previous: string,
  next: string,
  offset: number,
): number {
  let prefix = 0;
  while (
    prefix < previous.length &&
    prefix < next.length &&
    previous[prefix] === next[prefix]
  ) prefix += 1;
  let suffix = 0;
  while (
    suffix < previous.length - prefix &&
    suffix < next.length - prefix &&
    previous[previous.length - 1 - suffix] === next[next.length - 1 - suffix]
  ) suffix += 1;
  const previousEnd = previous.length - suffix;
  const nextEnd = next.length - suffix;
  if (previousEnd <= offset) return offset + nextEnd - previousEnd;
  if (prefix <= offset) return nextEnd;
  return offset;
}

export function removeTriggerAndPlaceChip(
  text: string,
  trigger: InputTrigger,
  label: string,
): StandaloneBarDraft {
  const next = removeInputTargetTrigger(text, trigger);
  return {
    text: next,
    chip: { label, offset: Math.min(trigger.start, next.length) },
  };
}
